/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type GetSourceEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * The kind of source that can be linked to an environment
 */
export const QueryParamSourceKind = {
  Http: "http",
  Function: "function",
} as const;
/**
 * The kind of source that can be linked to an environment
 */
export type QueryParamSourceKind = ClosedEnum<typeof QueryParamSourceKind>;

export type GetSourceEnvironmentRequest = {
  /**
   * The kind of source (http or function)
   */
  sourceKind: QueryParamSourceKind;
  /**
   * The slug of the source
   */
  sourceSlug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSourceEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSourceEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  GetSourceEnvironmentSecurity$Outbound,
  GetSourceEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSourceEnvironmentSecurityToJSON(
  getSourceEnvironmentSecurity: GetSourceEnvironmentSecurity,
): string {
  return JSON.stringify(
    GetSourceEnvironmentSecurity$outboundSchema.parse(
      getSourceEnvironmentSecurity,
    ),
  );
}

/** @internal */
export const QueryParamSourceKind$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamSourceKind
> = z.enum(QueryParamSourceKind);

/** @internal */
export type GetSourceEnvironmentRequest$Outbound = {
  source_kind: string;
  source_slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSourceEnvironmentRequest$outboundSchema: z.ZodMiniType<
  GetSourceEnvironmentRequest$Outbound,
  GetSourceEnvironmentRequest
> = z.pipe(
  z.object({
    sourceKind: QueryParamSourceKind$outboundSchema,
    sourceSlug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceKind: "source_kind",
      sourceSlug: "source_slug",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSourceEnvironmentRequestToJSON(
  getSourceEnvironmentRequest: GetSourceEnvironmentRequest,
): string {
  return JSON.stringify(
    GetSourceEnvironmentRequest$outboundSchema.parse(
      getSourceEnvironmentRequest,
    ),
  );
}
